import { Profitability } from './profitability';

export const state = () => ({
  priceProfitability: new Profitability(),
  isPriceProfitabilityLoading: false,
  boostedProductSet: new Set(),
  boostedMenuProductSet: new Set(),
});
